// ============================================================================
// Дизайн-система — чтение токенов из JS (ds.token)
// ============================================================================
// Для кода, который рисует ВНЕ DOM-каскада и не умеет var(--x): Chart.js,
// canvas, <meta theme-color>, JS-анимации. Читает ЖИВОЕ значение CSS-переменной
// с <html> — всегда совпадает с текущей темой (после ds.theme.set() повторное
// чтение вернёт уже новую тему).
//
//   ds.token('main')      → '74, 158, 255'   (триплет цвета)
//   ds.token('fs-footnote')  → '0.875rem'
//   `rgb(${ds.token('main')})` / `rgba(${ds.token('main')}, .12)`
//
// SSR: document нет → '' (не рисуем на сервере вне DOM).
export const token = name => {
  if (typeof document === 'undefined') return '';
  return getComputedStyle(document.documentElement)
    .getPropertyValue(`--${String(name).replace(/^--/, '')}`)
    .trim();
};
